export const apiRoutes = {
  health: "/api/health",
  catalog: "/api/catalog",
  results: "/api/results",
  resultJob: (jobId: string) => `/api/results/jobs/${encodeURIComponent(jobId)}`,
  turnstileSession: "/api/turnstile-session",
  token: "/api/token",
  decrypt: "/api/decrypt",
} as const;
